import React from 'react';
import reactLogo from '../../assets/images/react-logo.png';
import awsLogo from '../../assets/images/aws-logo.png';

const Footer = () => {
  return (
    <footer className="main-footer">
      <p>
        Built with{' '}
        <img src={reactLogo} alt="React" className="tech-logo" /> React frontend and{' '}
        <img src={awsLogo} alt="AWS" className="tech-logo aws-logo" /> AWS serverless architecture including Lambda, DynamoDB, Cognito, API Gateway, and EventBridge.
      </p>
    </footer>
  );
};

export default Footer;